import { ContentCopy } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { withStyles } from "@mui/styles";
import axios from "axios";
import { Fragment, useEffect, useMemo, useState } from "react";
import { isMobile, mobileModel, osName, osVersion } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../constants/apiConstants";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { VERSION } from "../../constants/version";
import { useAuth } from "../../context/auth-context";
import { useDeviceName } from "../../context/devicename-context";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import { FullPageSpinner } from "../lib";
import MessageBox from "../shared/components/MessageBox";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import openFile from "../shared/functions/download";

import Alert from "@mui/material/Alert";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);
const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);
const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
  },
}))(MuiAccordionDetails);

function Profile(props) {
  const { t } = useTranslation();
  const { client, deviceId, accessToken, updateTitle } = props;
  const { user, reloadUser } = useAuth();
  const [devices, setDevices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [expanded, setExpanded] = useState("panel-1");
  const [showModal, setShowModal] = useState(null);
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [deviceSettingsDialog, setDeviceSettingsDialog] = useState(false);
  const [newPrivateMail, setNewPrivateMail] = useState(user.mail2);
  const [newBusinessMail, setNewBusinessMail] = useState(user.mail);
  const { hideMessage, showErrorMessage, showSuccessMessage } = useMessage();
  const { deviceName } = useDeviceName();
  const [deviceVersion] = useState(localStorage.getItem(LOCAL_STORAGE_KEY.version) || VERSION);
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [currentDevice, setCurrentDevice] = useState("");
  const [newDeviceBez, setNewDeviceBez] = useState("");
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [email, setEmail] = useState("");
  const theme = useTheme();
  const navigate = useNavigate();
  useEffect(() => {
    if (user.deviceActivated === "J") {
      loadDevices();
    }
    // eslint-disable-next-line
  }, [user]);
  useEffect(() => {
    updateTitle(t("Account"));
    // eslint-disable-next-line
  }, []);

  const openMessageBox = () => {
    setMessageBoxOpen(true);
  };
  const closeMessageBox = () => {
    setMessageBoxOpen(false);
  };
  const messageBoxResult = (r) => {
    if (r === "YES") {
      deleteDevice();
    }
    closeMessageBox();
  };
  const loadDevices = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      deviceId: deviceId,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "devices", payload, headers, devicesCb);
  };
  const handleDeleteDevice = (devId) => {
    setCurrentDevice(devId);
    openMessageBox();
  };
  const deleteDevice = () => {
    setIsSending(true);
    const payload = {
      mandant: client,
      deviceId: currentDevice,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "devices/delete", payload, headers, deleteDeviceCb);
  };
  const deleteDeviceCb = (response) => {
    setIsSending(false);
    setDeviceSettingsDialog(false);
    setExpanded(false);
    if (response.status === 200) {
      showSuccessMessage(response.data.message);
      if (response.data.devices) {
        setDevices(response.data.devices);
      }
    } else {
      showErrorMessage(response.data.message);
    }
  };
  const devicesCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.devices) {
        setDevices(response.data.devices);
      }
      if (response.data.mail !== user.mail2 && user.mail2 !== "") {
        reloadUser();
      }
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const downloadFile = (file) => {
    console.log("file with key: ", file);
    const payload = {
      file: file,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "resources", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = file + ".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile, "application/pdf");
        loadingFinished();
      })
      .catch(function (error) {
        console.log(error);
        loadingFinished();
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  };
  const loadingFinished = () => {
    setShowModal(false);
  };
  const downloadAndOpenFile = (key) => {
    setShowModal(true);
    downloadFile(key);
  };
  const openPrivateInfoDialog = () => {
    setDialogIsOpen(true);
  };
  const openBezChangeDialog = (event, device) => {
    setNewDeviceBez(device.bez);
    setDeviceSettingsDialog(true);
    setSelectedDevice(device);
    event.stopPropagation();
  };
  const closePrivateInfoDialog = () => {
    resetPrivateInfoDialogData();
    setDialogIsOpen(false);
  };
  const detailsCB = (response) => {
    if (response.status === 200) {
      setNewPrivateMail(response.data.email);
      setEmail(response.data.email);
    }
  };

  useEffect(() => {
    if (dialogIsOpen) {
      const headers = {
        Authorization: "Bearer " + accessToken,
      };

      apiRequest("GET", "check-mail", null, headers, detailsCB, saveNewPrivateInfoErrorCb);
    }
  }, [dialogIsOpen]);

  const resetPrivateInfoDialogData = () => {};
  const saveSettings = () => {
    if (newDeviceBez !== selectedDevice.bez) {
      setIsSending(true);
      const payload = {
        deviceId: deviceId,
        selectedDevice: selectedDevice.deviceId,
        bez: newDeviceBez,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "devices/changename", payload, headers, saveSettingsCB, saveNewPrivateInfoErrorCb);
    } else {
      setDeviceSettingsDialog(false);
    }
  };
  const saveSettingsCB = (response) => {
    if (response.status === 200) {
      if (response.data.devices) {
        setDevices(response.data.devices);
      }
      setDeviceSettingsDialog(false);
      setIsSending(false);
      showSuccessMessage(response.data.message);
    } else {
      setIsSending(false);
      showErrorMessage(response.data.message);
    }
  };

  const saveNewPrivateInfo = () => {
    if (newPrivateMail !== user.mail2) {
      setIsSending(true);
      const payload = {
        deviceId: deviceId,
        privateMail: newPrivateMail,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "changemail", payload, headers, saveNewPrivateInfoCb, saveNewPrivateInfoErrorCb);
    } else {
      closePrivateInfoDialog();
    }
  };
  const saveNewPrivateInfoCb = (response) => {
    if (response.status === 200) {
      setIsSending(false);
      setDialogIsOpen(false);
      showSuccessMessage("Bitte bestätigen Sie Ihre E-Mail-Adresse über den gesendeten Verifizierungslink.");
    } else {
      setIsSending(false);
      setDialogIsOpen(false);
      showErrorMessage(response.data.message);
    }
  };
  const saveNewPrivateInfoErrorCb = (response) => {
    setIsSending(false);
    showErrorMessage(t("Speichern fehlgeschlagen."));
  };

  const sendVerifyToEmail = () => {
    setIsSending(true);
    const payload = {
      deviceId: deviceId,
      privateMail: email,
    };

    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    apiRequest("POST", "changemail", payload, headers, saveNewPrivateInfoCb, saveNewPrivateInfoErrorCb);
  };

  const handleChange = (panel) => (event, newExpanded) => {
    console.log(panel, newExpanded);

    setExpanded(newExpanded ? panel : false);
  };

  const handleCopyDeviceId = (selectedDeviceId) => {
    navigator.clipboard.writeText(selectedDeviceId);
    showSuccessMessage("Die deviceId wurde in die Zwischenablage kopiert");
  };

  const showThisDevice =
    devices.length > 0 ? (
      devices
        .filter((dev) => dev.deviceId === deviceId)
        .map((device, count) => {
          return (
            <Grid item xs={12} key={"panel-top"}>
              <Accordion square expanded={expanded === "panel-top"} onChange={handleChange("panel-top")}>
                <AccordionSummary
                  style={{
                    backgroundColor: theme.palette.background.highlight,
                  }}
                  aria-controls={"panel-top-content"}
                  id={"panel-top-header"}
                >
                  <Grid container justifyContent="space-between" alignItems="flex-start">
                    <Grid item>
                      <Typography>
                        1. {device.bez !== "" ? device.bez : device.name !== "false" && device.name !== "" ? device.name : device.operatingSystem}
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        ({t("Dieses Gerät")})
                      </Typography>
                    </Grid>

                    <Grid item>
                      <IconButton color="primary" size="small" onClick={(event) => openBezChangeDialog(event, device)}>
                        <EditIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        <TableRow key="name">
                          <TableCell>
                            <Typography variant="body1">{t("Name")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.name}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow key="bez">
                          <TableCell>
                            <Typography variant="body1">{t("Bezeichnung")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.bez}</Typography>
                          </TableCell>
                        </TableRow>
                        {/* <TableRow key="changeBez">
                      <TableCell colSpan={2}>
                        <Button fullWidth size="small" color="primary" onClick={() => openBezChangeDialog(device)}>{t("Bezeichnung ändern")}</Button>
                      </TableCell>
                    </TableRow> */}
                        <TableRow key="firstlogin">
                          <TableCell>
                            <Typography variant="body1">{t("Erster Login")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.firstLogin}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow key="lastlogin">
                          <TableCell>
                            <Typography variant="body1">{t("Letzter Login")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.lastLogin}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow key="os">
                          <TableCell>
                            <Typography variant="body1">{t("Betriebssystem")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.operatingSystem}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow key="devid">
                          <TableCell>
                            <Typography variant="body1">{t("GeräteId")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Grid container justifyContent={"end"} alignItems={"center"}>
                              <Grid item>
                                <Typography variant="body1">{device.deviceId.slice(0, 12) + "..."}</Typography>
                              </Grid>
                              <Grid item>
                                <Tooltip title="Deivce Id kopieren">
                                  <IconButton color="primary" onClick={() => handleCopyDeviceId(device.deviceId)}>
                                    <ContentCopy />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </TableCell>
                        </TableRow>
                        <TableRow key="devcode">
                          <TableCell>
                            <Typography variant="body1">{t("Gerätekennung")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.aktCode}</Typography>
                          </TableCell>
                        </TableRow>
                        {/* <TableRow key="deldevice">
                      <TableCell>
                        <Typography variant="body1">{t("Verknüpfung löschen")}</Typography>
                      </TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => handleDeleteDevice(device.deviceId)}><DeleteIcon color="error" /></IconButton>
                      </TableCell>
                    </TableRow> */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </Grid>
          );
        })
    ) : (
      <Grid item xs={12}>
        {t("verknüpfte Geräte konnten nicht geladen werden.")}
      </Grid>
    );
  const showDevices = useMemo(
    () =>
      devices.length > 0 &&
      devices
        .filter((dev) => dev.deviceId !== deviceId)
        .map((device, count) => {
          return (
            <Grid item xs={12} key={"panel" + count.toString()}>
              <Accordion square expanded={expanded === "panel-" + count.toString()} onChange={handleChange("panel-" + count.toString())}>
                <AccordionSummary aria-controls={"panel-" + count.toString() + "d-content"} id={"panel-" + count.toString() + "d-header"}>
                  {/* <Typography>{count + 2}. {device.bez !== "" ? device.bez : (device.name !== "false" && device.name !== "") ? device.name : device.operatingSystem}</Typography> */}
                  <Grid container spacing={"5"}>
                    <Grid item>
                      <Typography>
                        {" "}
                        {count + 2}. {device.bez !== "" ? device.bez : device.name !== "" ? device.name : device.operatingSystem}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <IconButton color="primary" size="small" onClick={(event) => openBezChangeDialog(event, device)}>
                      <EditIcon />
                    </IconButton>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        <TableRow key="name">
                          <TableCell>
                            <Typography variant="body1">{t("Name")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.name}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow key="bez">
                          <TableCell>
                            <Typography variant="body1">{t("Bezeichnung")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.bez}</Typography>
                          </TableCell>
                        </TableRow>
                        {/* <TableRow key="changeBez">
                      <TableCell colSpan={2}>
                        <Button fullWidth size="small" color="primary" onClick={() => openBezChangeDialog(device)}>{t("Bezeichnung ändern")}</Button>
                      </TableCell>
                    </TableRow> */}
                        <TableRow key="firstlogin">
                          <TableCell>
                            <Typography variant="body1">{t("Erster Login")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.firstLogin}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow key="lastlogin">
                          <TableCell>
                            <Typography variant="body1">{t("Letzter Login")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.lastLogin}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow key="os">
                          <TableCell>
                            <Typography variant="body1">{t("Betriebssystem")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.operatingSystem}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow key="devid">
                          <TableCell>
                            <Typography variant="body1">{t("GeräteId")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Grid container justifyContent={"end"} alignItems={"center"}>
                              <Grid item>
                                <Typography variant="body1">{device.deviceId.slice(0, 12) + "..."}</Typography>
                              </Grid>
                              <Grid item>
                                <Tooltip title="Deivce Id kopieren">
                                  <IconButton color="primary" onClick={() => handleCopyDeviceId(device.deviceId)}>
                                    <ContentCopy />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </TableCell>
                        </TableRow>
                        <TableRow key="devcode">
                          <TableCell>
                            <Typography variant="body1">{t("Gerätekennung")}</Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body1">{device.aktCode}</Typography>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
              <Divider />
            </Grid>
          );
        }),
    [devices, expanded],
  );

  return (
    <Page>
      <Box p={2} sx={{ overflowX: "hidden" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Grid container spacing={2} direction="column">
              <Grid item xs={12}>
                <Paper>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow key="acc">
                          <TableCell colSpan={2}>
                            <Typography>{t("Accountinformationen")}</Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow key="uid">
                          <TableCell>{t("User ID")}</TableCell>
                          <TableCell align="right">
                            <Typography>{user.id}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow key="username">
                          <TableCell>{t("Username")}</TableCell>
                          <TableCell align="right">
                            <Typography>{user.name}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell key="loginname">{t("Anmeldename")}</TableCell>
                          <TableCell align="right">
                            <Typography>{props.username}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell key="loginname">{t("Gerätename")}</TableCell>
                          <TableCell align="right">
                            <Typography>{deviceName}</Typography>
                          </TableCell>
                        </TableRow>
                        {isMobile && (
                          <TableRow key="device">
                            <TableCell>{t("Gerät")}</TableCell>
                            <TableCell align="right">
                              <Typography>{mobileModel}</Typography>
                            </TableCell>
                          </TableRow>
                        )}
                        <TableRow key="os">
                          <TableCell>{t("Betriebssystem")}</TableCell>
                          <TableCell align="right">
                            <Typography>
                              {osName} {osVersion}
                            </Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow key="version">
                          <TableCell>{t("Version")}</TableCell>
                          <TableCell align="right">
                            <Typography>{deviceVersion}</Typography>
                          </TableCell>
                        </TableRow>
                        {deviceVersion !== VERSION && (
                          <TableRow key="build">
                            <TableCell>{t("Build")}</TableCell>
                            <TableCell align="right">
                              <Typography>{VERSION}</Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper sx={{ p: 2 }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                      <Typography>{t("Persönliche Daten")}</Typography>
                    </Grid>

                    <Grid item>
                      <IconButton color="primary" onClick={() => openPrivateInfoDialog()}>
                        <EditIcon />
                      </IconButton>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid container item xs={12}>
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                          textAlign: { xs: "center", sm: "left" },
                        }}
                      >
                        <Typography variant="body2">{t("Private Mail")}</Typography>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={8}
                        sx={{
                          textAlign: { xs: "center", sm: "right" },
                        }}
                      >
                        <Typography sx={{ wordBreak: "break-word" }}>{user.mail2 || t("Keine Mail-Adresse angegeben")}</Typography>
                      </Grid>
                    </Grid>

                    <Grid container item xs={12}>
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                          textAlign: { xs: "center", sm: "left" },
                        }}
                      >
                        <Typography variant="body2">{t("Business Mail")}</Typography>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={8}
                        sx={{
                          textAlign: { xs: "center", sm: "right" },
                        }}
                      >
                        <Typography sx={{ wordBreak: "break-word" }}>{user.mail || t("Keine Mail-Adresse angegeben")}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              {/* <ProfileLohnDetails daten={steuerDaten} ></ProfileLohnDetails> */}
              <Grid item xs={12}>
                <Paper>
                  <Button fullWidth color="primary" onClick={() => navigate("/change-password")}>
                    {t("Passwort ändern")}
                  </Button>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow key="legal">
                          <TableCell>
                            <Typography>{t("Rechtliche Informationen")}</Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow key="agb">
                          <TableCell>
                            <Button color="primary" onClick={() => downloadAndOpenFile("IMPRESSUM")}>
                              {t("Impressum & Datenschutzerklärung")}
                            </Button>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper>
              <Grid container>
                <Grid item xs={12} align="left">
                  <Box p={2}>
                    <Typography>{t("Meine Geräte")}</Typography>
                  </Box>
                </Grid>
                {isLoading ? (
                  <Grid item xs={12}>
                    <CircularProgress />
                  </Grid>
                ) : (
                  <Fragment>
                    {showThisDevice}
                    {showDevices}
                  </Fragment>
                )}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <ResponsiveDialog
          open={dialogIsOpen}
          setOpen={() => closePrivateInfoDialog()}
          maxWidth="md"
          title={t("Persönliche Daten ändern")}
          actionButton={
            <>
              {email && (
                <Tooltip title={t("Sie haben bereits eine E-Mail-Verifizierung im Gange. Sie können sich die E-Mail erneut zusenden lassen.")}>
                  <Button color="primary" variant="contained" onClick={sendVerifyToEmail}>
                    {t("Verifizierung erneut senden")}
                  </Button>
                </Tooltip>
              )}
              <Button sx={{ marginRight: "1em" }} color="primary" variant="contained" onClick={saveNewPrivateInfo}>
                {t("Speichern")}
              </Button>
            </>
          }
        >
          <Box p={1}>
            <Grid container>
              <Grid item xs={12}>
                <Box p={1}>
                  <TextField
                    label={t("Private E-Mail")}
                    value={newPrivateMail}
                    onChange={(event) => setNewPrivateMail(event.target.value)}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    helperText={user.mail2 ? "Aktuelle E-Mail: " + user.mail2 : ""}
                  />
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box p={1}>
                  <TextField
                    label={t("Business E-Mail")}
                    disabled={true}
                    value={newBusinessMail}
                    onChange={(event) => setNewBusinessMail(event.target.value)}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                  />
                </Box>
              </Grid>
              {email && (
                <Grid item xs={12}>
                  <Box p={1}>
                    <Alert severity="warning">
                      {t("Sie haben bereits eine neue E-Mail Adresse beantragt aber noch nicht bestätigt.") + " (" + email + ")"}
                    </Alert>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </ResponsiveDialog>
        <ResponsiveDialog
          open={deviceSettingsDialog}
          setOpen={() => setDeviceSettingsDialog()}
          maxWidth="md"
          title={t("Geräte Einstellungen")}
          actionButton={
            <>
              <Button color="primary" variant="contained" onClick={saveSettings}>
                {t("Speichern")}
              </Button>
              <IconButton color="error" size="small" onClick={() => handleDeleteDevice(selectedDevice.deviceId)}>
                {t("Verknüpfung löschen")}
                <DeleteIcon color="error" />
              </IconButton>
            </>
          }
        >
          <Box p={1}>
            <Grid container>
              <Grid item xs={12}>
                <Box p={1}>
                  <TextField
                    label={t("Geräte Bezeichnung")}
                    value={newDeviceBez}
                    onChange={(event) => setNewDeviceBez(event.target.value)}
                    fullWidth
                    variant="outlined"
                  />
                </Box>
              </Grid>
              {/* <Grid item xs={12}>
              <Box p={1}>
                <TextField
                  label={t("Business E-Mail")}
                  value={newBusinessMail}
                  onChange={(event) => setNewBusinessMail(event.target.value)}
                  fullWidth
                  variant="outlined"
                />
              </Box>
            </Grid> */}
            </Grid>
          </Box>
        </ResponsiveDialog>

        {isSending && <FullPageSpinner />}
        {showModal && <FullPageSpinner />}
        <MessageBox
          title={t("Hinweis")}
          text={t("Wollen Sie die Verknüpfung zu diesem Gerät wirklich löschen?")}
          buttons="YESNO"
          onClose={closeMessageBox}
          open={messageBoxOpen}
          handleResponse={messageBoxResult}
        />
      </Box>
    </Page>
  );
}
export default Profile;
